import "./Modal.css"


function Modal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <>
            <div
                className="modaloverlay"
                onClick={onClose}
                role="dialog"
                aria-modal="true"
            >
                <div
                    className="modalcontent"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button                                                className="modalclosebutton"
                        onClick={onClose}
                        aria-label="Close modal">
                    X
                    </button>
                    <div className="modaldescription">
                        <h3>Amblyopi</h3>
                        <p>
                        Tänk dig att dina ögon är som ett par kameror som skickar bilder till hjärnan. Vid ett tillstånd som kallas "lat öga" (eller amblyopi på medicinskt språk) fungerar inte en av dessa kameror som den ska.</p>
                        <h4>
                            Så här kan man förklara det enkelt:
                        </h4>
                        
                        <ul>
                            <li>
                                Det är som att ha två TV-apparater, där den ena visar en suddig bild medan den andra visar klart.
                            </li>
                            <li>
                                När hjärnan får två olika bilder - en suddig och en klar - väljer den att mest använda den klara bilden. Med tiden blir det som att hjärnan "stänger av" det öga som visar suddigt.
                            </li>
                            <li>
                                Detta händer oftast hos små barn och är faktiskt det vanligaste synproblemet bland barn.                            
                            </li>
                        </ul>

                        <h4>
                        Det viktiga att veta är att:
                        </h4>
                        <ul>
                            <li>
                                Det har ingenting med lathet att göra - barnet kan inte själv påverka detta.
                            </li>
                            <li>
                                Om man upptäcker det tidigt kan det behandlas framgångsrikt.  
                            </li>
                            <li>
                                Behandlingen kan vara så enkel som att använda en lapp för det friska ögat eller speciella glasögon.  
                            </li>
                        </ul>
                        
                        <h4>
                        Tecken att vara uppmärksam på hos barn:
                        </h4>
                        <ul>
                            <li>
                                De kisar ofta med ett öga
                            </li>
                            <li>
                                Lutar huvudet åt sidan
                            </li>
                            <li>
                                Har svårt att bedöma avstånd
                            </li>
                            <li>
                                Springer in i saker på en viss sida
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Modal
